import { createSelector } from 'reselect';
import { createGenericOptionsSelector } from 'ContentData/helpers/reduxHelpers';
import IntegrationStatuses from 'ContentUtils/constants/IntegrationStatuses';
export const getCampaign = (state, props) => state.resources.salesforce.campaigns[props.id];
export const getCampaigns = state => state.resources.salesforce.campaigns;
export const getCampaignFetchStatus = (state, props) => state.resources.salesforce.campaignsRequestStatus[props.id];
export const getCampaignCache = (state, props) => props.id ? state.resources.salesforce.campaignsCache[props.id] : undefined;
export const getCampaignsCache = state => state.resources.salesforce.campaignsCache;
export const getCampaignsCacheRequestStatus = state => state.resources.salesforce.campaignsCacheRequestStatus;
export const getCampaignsOptions = createGenericOptionsSelector(getCampaignsCache);
export const getDefaultCampaignsOptions = createGenericOptionsSelector(getCampaigns);
export const getIntegrationStatus = (state, props) => props.integrationStatus || state.resources.salesforce.integrationStatus;
export const getIsIntegrated = createSelector([getIntegrationStatus], integrationStatus => {
  return integrationStatus === IntegrationStatuses.CONNECTED;
});